interface RequestRepeaterStorage {
  [key: string]: number;
}

class RequestRepeatStorage {
  private readonly storageName!: string;

  private readonly emptyStorageData!: string;

  constructor() {
    this.storageName = 'request-repeat-storage';
    this.emptyStorageData = '{}';

    this.resetWatcher();
  }

  private get rawStorageData(): string {
    return localStorage.getItem(this.storageName) || this.emptyStorageData;
  }

  private get storageData(): RequestRepeaterStorage {
    return JSON.parse(this.rawStorageData);
  }

  public rememberRequest(name: string): void {
    const data = {
      ...this.storageData,
      [name]: 0,
    };

    localStorage.setItem(this.storageName, JSON.stringify(data));
  }

  public hasRequest(name: string): boolean {
    return this.storageData[name] !== undefined;
  }

  public getRequestTry(name: string): number {
    return this.storageData[name] || 0;
  }

  public incrementRequestTry(name: string): void {
    const data = {
      ...this.storageData,
    };

    if (this.hasRequest(name)) {
      data[name]++;
    }

    localStorage.setItem(this.storageName, JSON.stringify(data));
  }

  public resetRequest(name: string): void {
    this.rememberRequest(name);
  }

  public resetWatcher(): void {
    localStorage.setItem(this.storageName, this.emptyStorageData);
  }
}

const requestRepeatStorage = new RequestRepeatStorage();

export {
  requestRepeatStorage,
};
